import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { CreateCheckoutSessionRequest, CreateCheckoutSessionResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Create a Stripe Checkout Session for subscription payment
 * @param request - Checkout session parameters
 * @returns Stripe Checkout Session with URL to redirect to
 */
export async function createCheckoutSession(
  request: CreateCheckoutSessionRequest
): Promise<CreateCheckoutSessionResponse> {
  const response = await AuthAxios.post<CreateCheckoutSessionResponse>(
    `${ENDPOINT_SUBSCRIPTIONS}/create-checkout-session`,
    request
  )
  return response.data
}
